import { Box } from '@mui/material'
import { TallymanV2ViewStore } from '@planning/rt-stores/tallyman/TallymanV2ViewStore'
import { useTranslate } from '@tolgee/react'
import { Header, IconButton, MenuIcon, useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { FC, useEffect, useMemo } from 'react'
import { CheckSuccessAlert } from './Components/CheckSuccessAlert'
import { ContainerSearchBox } from './Components/ContainerSearchBox'
import { HeaderAvatar } from './Components/HeaderComponents/HeaderAvatar'
import { ReportSuccessAlert } from './Components/ReportSuccessAlert'

interface IProps {
  store: TallymanV2ViewStore
  onSearchClick: () => void
  onCancelCheckRequest: () => void
  openDrawer: () => void
  operationStoppedComponent?: React.ReactNode
}

export const ContainerOperations: FC<IProps> = observer(
  ({ store, onSearchClick, onCancelCheckRequest, openDrawer, operationStoppedComponent }) => {
    const theme = useMinimalsTheme()
    const { t } = useTranslate()
    const { vesselTallyStore } = store
    const { checkNotificationStore, reportNotificationStore } = vesselTallyStore

    const operation = vesselTallyStore.selectedOperation
    const vesselVisit = vesselTallyStore.selectedVisit

    const vesselData = vesselVisit?.vessels[0]?.data
    const headerTitle = vesselVisit?.data?.number
      ? `${vesselVisit?.data?.number} - ${vesselData?.name}`
      : vesselData?.name

    const headerSubtitle = useMemo(() => {
      const subtitle: string[] = []

      if (operation) subtitle.push(t(operation.toString()))

      if (vesselTallyStore.selectedCrane) subtitle.push(vesselTallyStore.selectedCrane.name)

      return subtitle.join(' - ')
    }, [operation, vesselTallyStore.selectedCrane, t])

    useEffect(() => {
      window.scrollTo(0, 0)
    }, [])

    return (
      <>
        <Header
          title={headerTitle}
          subTitle={headerSubtitle}
          leftRenderOption={
            vesselTallyStore.isSelectedVisitInOperation ? (
              <IconButton onClick={openDrawer} data-cy='open-navigation-drawer'>
                <MenuIcon />
              </IconButton>
            ) : undefined
          }
          rightRenderOption={<HeaderAvatar />}
        />

        <Box
          sx={{
            backgroundColor: theme.palette.grey[200],
            minHeight: 'calc(100vh - 65px)',
            padding: '1rem',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
          gap={theme.customSpacing.m}
        >
          <ContainerSearchBox store={store} onSearchClick={onSearchClick} />

          {operationStoppedComponent}

          {checkNotificationStore.request && (
            <CheckSuccessAlert store={checkNotificationStore} onCancel={onCancelCheckRequest} />
          )}
          {reportNotificationStore.request && (
            <ReportSuccessAlert store={reportNotificationStore} />
          )}
        </Box>
      </>
    )
  },
)
